import { z } from 'zod';

/**
 * Who wrote a study's title.
 *
 * - `placeholder` — nobody: the study still carries the title it was created with.
 * - `sigora` — Sigora named it, from the materials or from the conversation.
 * - `user` — the researcher renamed it.
 */
export const TITLE_SOURCES = ['placeholder', 'sigora', 'user'] as const;
export const titleSourceSchema = z.enum(TITLE_SOURCES);
export type TitleSource = z.infer<typeof titleSourceSchema>;

/**
 * Whether a title write from `incoming` may replace a title written by `current`.
 *
 * The researcher may always rename. Sigora may name a study until the researcher has, and never
 * after: a rename is the researcher saying what the study is called, and a proposal that
 * overwrote it would undo that without asking. Nothing writes the placeholder back, since it is
 * only what a study is created with.
 */
export const titleWriteAllowed = (current: TitleSource, incoming: TitleSource): boolean => {
  switch (incoming) {
    case 'user': {
      return true;
    }
    case 'sigora': {
      return current !== 'user';
    }
    case 'placeholder': {
      return false;
    }
  }
};
